import { createContext, useCallback, useContext, useEffect, useState } from "react";

const SidebarContext = createContext({
  collapsed: false, toggle: () => {},
  mobileOpen: false, setMobileOpen: () => {},
});

const STORAGE_KEY = "alp.sidebar.collapsed.v1";
const W_EXPANDED = "260px";
const W_COLLAPSED = "80px";

function applyCssVar(collapsed) {
  try {
    document.documentElement.style.setProperty(
      "--al-sidebar-w",
      collapsed ? W_COLLAPSED : W_EXPANDED,
    );
  } catch (_e) { /* ignore */ }
}

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    try { return window.localStorage.getItem(STORAGE_KEY) === "1"; }
    catch (_e) { return false; }
  });
  // Iter175 — mobile drawer state (open/close). Not persisted: mobile users
  // expect the drawer to close on every navigation.
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => { applyCssVar(collapsed); }, [collapsed]);

  // Auto-close drawer whenever we resize back to desktop (≥1024px).
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(min-width: 1024px)");
    const onChange = (e) => e.matches && setMobileOpen(false);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  const toggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try { window.localStorage.setItem(STORAGE_KEY, next ? "1" : "0"); } catch (_e) { /* ignore */ }
      return next;
    });
  }, []);

  return (
    <SidebarContext.Provider value={{ collapsed, toggle, mobileOpen, setMobileOpen }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebarState() {
  return useContext(SidebarContext);
}
